






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class PlantBackground extends Vue {
  @Prop() readonly image!: string;

  get imgSrc() {
    return this.image || "/foto_blur_planten.jpg";
  }
}
